import rq from "./rq.js";
export function currencyFormat(numberString) {
    if (numberString === null || numberString === undefined) {
        return "0.00";
    }
    var addMinus = "";
    if (numberString < 0) {
        addMinus = "-";
        numberString = numberString * -1;
    }
    numberString = (numberString === 0 ? 0 : numberString);
    numberString = numberString.toString();
    var pattern = [3, 2, 2];

    let arr = numberString.split(".");
    let number = arr[0];

    var decimal = arr[1] || "00";
    number = number.split("");
    var i = 0;
    var text = "";
    while (number.length !== 0) {
        var result = number.splice(-pattern[i]);
        text = number.length > 0 ? "," + result.join("") + text : result.join("") + text;
        i = i === 2 ? 0 : ++i;
    }
    if (decimal.length === 1) {
        decimal = decimal.toString() + "0";
    }
    return addMinus + text + "." + decimal.substring(0, 2);
}

export function cFormat(numberString) {
    numberString = numberString || "";
    numberString = numberString.toString();
    var pattern = [3, 2, 2];
    let number = numberString;
    number = number.split("");
    var i = 0;
    var text = "";
    while (number.length !== 0) {
        var result = number.splice(-pattern[i]);
        text = number.length > 0 ? "," + result.join("") + text : result.join("") + text;
        i = i === 2 ? 0 : ++i;
    }
    return text;
}

export function dateTimeFormat(localDateTime) {
    return localDateTime.split("T").join(" ");
}

export function dateToYY_MM_DD(dt) {

    return `${dt.getFullYear()}-${dt.getMonth() < 9 ? "0" + (dt.getMonth() + 1) : (dt.getMonth() + 1)}-${dt.getDate() < 10 ? "0" + (dt.getDate()) : (dt.getDate())}`;
}

export function getDateRench(num) {
    var x = new Date();
    var y = new Date();
    y.setDate(y.getDate() - num);
    return [dateToYY_MM_DD(y), dateToYY_MM_DD(x)];
}
export function toExactFixted(number, toPoint = 0) {
    if (number === undefined || number === null) {
        return "0." + new Array(toPoint + 1).join("0");
    }
    number = number.toString();

    var arr = number.split(".");
    if (toPoint === 0)
        return arr[0];
    var d = "";
    let len = 0;


    if (arr[1] >= 0) {
        len = arr[1].length;
    }

    let value = toPoint - len;
    if (value > 0) {
        for (var i = 0; i < value; i++) {
            d += "0";
        }
        d = (arr[1] || "") + d;
    } else if (value === 0) {
        d = arr[1] + "";
    } else if (value < 0) {
        d = arr[1].substring(0, toPoint);

    }
    return arr[0] + "." + d;
}

export function DD_MM_YY(dt) {
    if (Date.parse(dt)) {
        var d = new Date(dt);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        day = day < 10 ? "0" + day : day;
        month = month < 10 ? "0" + month : month;
        return `${day}-${month}-${d.getFullYear()}`;
    } else {
        return null;
    }

}

export function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
}

export function extractDataFromTable(tableId) {
    var arr = [];
    var table = document.getElementById(tableId);
    for (var i = 0; i < table.rows.length; i++) {
        arr[i] = [];
        for (var z = 0; z < table.rows[i].cells.length; z++) {
            var cName = table.rows[i].cells[z].className;
            var align = "";
            switch (cName) {
                case "currency": {
                    align = "right";
                    break;
                }
                case "alignRight": {
                    align = "right";
                    break;
                }
                case "center": {
                    align = "center";
                    break;
                }
                default: {
                    align = "left";
                    break;
                }

            }
            arr[i][z] = { text: cName === "currency" ? "\u20B9" + table.rows[i].cells[z].innerText.trim() : table.rows[i].cells[z].innerText.trim(), alignment: align };
        }
    }
    // console.log(arr);
    var widths = [];
    if (arr.length > 0) {
        for (let i = 0; i < arr[0].length; i++) {
            widths.push("*");
        }
    }
    return { data: arr, widths };
}

export function getDoubleLine() {
    return {
        canvas: [
            {
                type: 'line',
                x1: 0, y1: 7,
                x2: 520, y2: 7,
                lineWidth: 1
            },
            {
                type: 'line',
                x1: 0, y1: 10,
                x2: 520, y2: 10,
                lineWidth: 2
            }

        ]
    };
}

export function print(data, cb) {
    rq.postJson("/api/v1/print", data).then((file) => {
        //print(file);
        //var link = document.createElement('a');

        //window.print();
        //link.setAttribute('download', "manas.pdf");
        //link.setAttribute("target", "_blank");
        //document.body.appendChild(link);
        //link.click();
        //document.body.removeChild(link);
        //document.print();
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        if (cb)
            cb();

    }).catch((err) => {
        throw err;
    });

}

export function dateDiff(to, from) {
    var diff = Math.abs(new Date(to) - new Date(from));
    var oneDay = 24 * 60 * 60 * 1000;

    return diff / oneDay;
}


export function matchDate(dt1, dt2) {
    if (dt1 && dt2)
        return dt1.getTime() === dt2.getTime();
    else
        return false;
}


export function inWords(amount) {
    amount = parseFloat(amount);
    if (!amount)
        return "";
    //const currency = currencyFormat(amount);
    let [rupees, paisa] = amount.toString().split(".");
    //const rupeesArr = rupees.split(",");
    paisa = paisa ? paisa : "";

    //console.log(rupees, paisa);

    function numberToWord(number) {
        number = parseInt(number, 10);
        switch (number) {
            case 1:
                return "One";
            case 2:
                return "Two";
            case 3:
                return "Three";
            case 4:
                return "Four";
            case 5:
                return "Five";
            case 6:
                return "Six";
            case 7:
                return "Seven";
            case 8:
                return "Eight";
            case 9:
                return "Nine";
            default:
                return "";
        }
    }

    function sndNumberToWord(number) {
        number = parseInt(number, 10);
        switch (number) {
            case 2:
                return "Twenty";
            case 3:
                return "Thirty";
            case 4:
                return "Fourty";
            case 5:
                return "Fifty";
            case 6:
                return "Sixty";
            case 7:
                return "Seventy";
            case 8:
                return "Eighty";
            case 9:
                return "Ninty";
            default:
                return "";

        }
    }

    function checkNums(num) {
        //  num = ;
        // console.log(parseInt(num, 10));
        if (parseInt(num, 10) === 0)
            return "";

        switch (num.length) {
            case 1:
                return numberToWord(num[0]);
            case 2: {

                const numx = parseInt(num, 10);
                if (numx >= 10 && numx <= 20)
                    return handleTenToTwentyOne(numx);
                return (sndNumberToWord(num[0]) + " " + numberToWord(num[1])).trim();
            }
            case 3: {
                //const numx = parseInt(num.substring(1, 2), 10);

                return ((numberToWord(num[0]) ? numberToWord(num[0]) + " Hundred" : "") + " " + checkNums(num.substring(1, 3))).trim();
            }
            case 4: {

                return ((checkNums(num[0]) ? checkNums(num[0]) + " Thousand" : "") + " " + checkNums(num.substring(1, 4))).trim();
            }
            case 5: {
                return ((checkNums(num.substring(0, 2)) ? " " + checkNums(num.substring(0, 2)) + " Thousand" : "") + " " + checkNums(num.substring(2, 5))).trim();
            }
            case 6: {
                return ((checkNums(num.substring(0, 1)) ? " " + checkNums(num.substring(0, 1)) + " Lakh" : "") + " " + checkNums(num.substring(1, 6))).trim();
            }
            case 7: {
                return ((checkNums(num.substring(0, 2)) ? " " + checkNums(num.substring(0, 2)) + " Lakh" : "") + " " + checkNums(num.substring(2, 7))).trim();
            }
            case 8: {
                return ((checkNums(num.substring(0, 1)) ? " " + checkNums(num.substring(0, 1)) + " Crore" : "") + " " + checkNums(num.substring(1, 8))).trim();
            }
            default: {
                return (checkNums(num.substring(0, num.length - 7)) + " Corer " + checkNums(num.substring(num.length - 7, num.length))).trim();
            }
        }
    }

    function handleTenToTwentyOne(num) {
        switch (num) {
            case 10:
                return "Ten";
            case 11:
                return "Eleven";
            case 12:
                return "Tweleve";
            case 13:
                return "Thirteen";
            case 14:
                return "Fourteen";
            case 15:
                return "Fifteen";
            case 16:
                return "Sixteen";
            case 17:
                return "Seventeen";
            case 18:
                return "Eighteen";
            case 19:
                return "Ninteen";
            case 20:
                return "Twenty";
        }
    }


    let inrupeesWords = "";
    let paisaWords = "";

    inrupeesWords = checkNums(rupees);

    if (paisa.length > 0) {
        let _p;
        if (paisa.length >= 2)
            _p = paisa.substring(0, 2);
        else
            _p = paisa + "0";


        paisaWords = checkNums(_p);
    }

    //console.log("ruppes", inrupeesWords === "");
    const final = ((inrupeesWords ? `${inrupeesWords} Rupees` : "") + (paisaWords ? ` and ${paisaWords} Paisa` : "")).trim();

    return (final ? final + " Only" : "");

}


// WEBPACK FOOTER //
// ./src/jsx/components/utility/util-methods.jsx